import React, { forwardRef, useImperativeHandle, useRef } from "react";
import ScheduleForm from "../Forms/ScheduleForm";
import LocationForm from "../Forms/LocationForm";
import ContactsForm from "../Forms/ContactsForm";
import TasksForm from "../Forms/TasksForm";
import { combineValidationResults } from "../../../utils/formErrors";

const Scheduling = forwardRef(({ isEditMode }, ref) => {
  const locationRef = useRef();
  const scheduleRef = useRef();
  useImperativeHandle(ref, () => ({
    isValid: () =>
      combineValidationResults(locationRef.current?.isValid?.(), scheduleRef.current?.isValid?.()),
  }));

  return (
    <div>
      <LocationForm ref={locationRef} isEditMode={isEditMode} />
      <ScheduleForm ref={scheduleRef} />
      {!isEditMode && <TasksForm />}
      {!isEditMode && <ContactsForm />}
    </div>
  );
});

export default Scheduling;
